module.exports = __webpack_public_path__ + "static/img/wechatDescribe.1c5b2155.png";